import { Extension } from '@tiptap/core';

// Tags textStyle spans that carry a color the user deliberately picked with
// data-user-color="true". DocumentEditor.css neutralizes the color of any
// span WITHOUT this attribute (pasted content with unreadable hardcoded
// colors); spans with it keep their exact color — including black, which is
// what the highlight-contrast mapping applies on light highlights.
export const UserColor = Extension.create({
    name: 'userColor',

    addGlobalAttributes() {
        return [
            {
                types: ['textStyle'],
                attributes: {
                    userColor: {
                        default: null,
                        parseHTML: (element) => element.getAttribute('data-user-color'),
                        renderHTML: (attributes) => {
                            if (!attributes.userColor) return {};
                            return { 'data-user-color': attributes.userColor };
                        },
                    },
                },
            },
        ];
    },
});
